import * as bip39 from 'bip39'
import { KeyPair } from './keyPair.js'
import {NETWORK, NETWORK_PATH} from '../constants.js'
import * as bip32 from 'bip32'
import ExtendedKey from './ExtendedKey.js'
// import * as ecc from 'tiny-secp256k1';
// const bip32 = bip32Default.BIP32Factory(ecc);

// Generate a mnemonic using bip39 library
export function generateMnemonic(){
    // generate a 128 bits, 12 words mnemonic
    return bip39.generateMnemonic(128)
}

// Generate a keypair using mnemonic
export function keyPairFromMnemonic(network, index, mnemonic){
    
    if(!network){
        throw new Error('No Network defined')
    }

    var path = ''
    let testnet = false;
    if(network === NETWORK.MAINNET){
        path = "m/44'/" + NETWORK_PATH.MAINNET_PATH + "'/0'/0/" + index.toString()
    }else if(network === NETWORK.TESTNET){
        path = "m/44'/" + NETWORK_PATH.TESTNET_PATH + "'/0'/0/" + index.toString() 
        testnet = true
    }else{
        throw new Error('Unsupported Network')
    }

    // if (password === undefined) {
    //     throw new Error("'password' argument must be of type string or an instance of Buffer or ArrayBuffer. Received undefined");
    // }
    const seed = bip39.mnemonicToSeed(mnemonic);
    // return keyDeriveFromSeed(seed, path);

    if (typeof seed === 'string') {
        seed = Buffer.from(seed, 'hex');
    }
    // console.log('seed', seed.toString('hex'))
    const masterKey = bip32.fromSeed(seed);
    // console.log('masterKey', masterKey)
    // console.log('path', path)
    const childKey = masterKey.derivePath(path);
    if (!childKey.privateKey) {
        throw new Error('privateKey not generated');
    }
    
    const account =  new ExtendedKey(childKey.privateKey, testnet);
    
    
    // const account = filecoin_signing_tools.keyDerive(mnemonic, path, password)
    const keypair = new KeyPair(account.publicKey.toString('hex'), account.privateKey.toString('hex'), account.address)
    // const keypair = new KeyPair(account.publicKey, account.privateKey, account.address)
    return keypair
}

export function keyPairFromPrivateKey(network, privateKey){
    if(!network){
        throw new Error('No Network defined')
    }

    // var path = ''
    let testnet = false;
    if(network === NETWORK.MAINNET){
        // path = "m/44'/" + NETWORK_PATH.MAINNET_PATH + "'/0'/0/" + index.toString()
    }else if(network === NETWORK.TESTNET){
        // path = "m/44'/" + NETWORK_PATH.TESTNET_PATH + "'/0'/0/" + index.toString() 
        testnet = true
    }else{
        throw new Error('Unsupported Network')
    }

    // if (password === undefined) {
    //     throw new Error("'password' argument must be of type string or an instance of Buffer or ArrayBuffer. Received undefined");
    // }
    // const seed = bip39.mnemonicToSeed(mnemonic);
    // return keyDeriveFromSeed(seed, path);

    if (typeof privateKey === 'string') {
        privateKey = Buffer.from(privateKey, 'hex');
    }
    // console.log('seed', seed.toString('hex'))
    // const masterKey = bip32.fromSeed(seed);
    // // console.log('masterKey', masterKey)
    // // console.log('path', path)
    // const childKey = masterKey.derivePath(path);
    // if (!childKey.privateKey) {
    //     throw new Error('privateKey not generated');
    // }
    
    const account =  new ExtendedKey(privateKey, testnet);
    
    
    // const account = filecoin_signing_tools.keyDerive(mnemonic, path, password)
    const keypair = new KeyPair(account.publicKey.toString('hex'), account.privateKey.toString('hex'), account.address)
    // const keypair = new KeyPair(account.publicKey, account.privateKey, account.address)
    return keypair

}

